import React, { useEffect } from 'react'

export default function Page404() {

  // Scroll to the top of the page when the component mounts
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <main>
      <div>page404</div>
    </main>
  )
}
